const Popup = {

	init: () => {
		Popup.initOpenButton();
		Popup.initCloseButton();
		Popup.initCloseOnOtherClick();
		Popup.initVideoPlayButton();
	},

	initVideoPlayButton: () => {
		const buttons = document.querySelectorAll(`[data-popup-video-play]`);
		buttons.forEach((element) => {
			element.addEventListener('click', (ev) => {
				ev.preventDefault();
				const popup = element.closest('[data-popup]');
				if(!popup) return;
				Popup.play(popup);
			})
		})
	},

	play: (popup) => {
		const video = popup.querySelector(`[data-popup-video]`);
		if(!video){
		    return;
		}
		popup.classList.add('playing-video');
		video.play();
	},

	initCloseOnOtherClick: () => {
		const popups = document.querySelectorAll(`[data-popup]`);
		popups.forEach((element) => {
		    element.addEventListener('click', () => {
				Popup.close();
			});
		});
		const contents = document.querySelectorAll(`[data-popup-content]`);
		contents.forEach((element) => {
			element.addEventListener('click', (ev) => {
				ev.stopPropagation();
			});
		})
	},

	initCloseButton: () => {
		const buttons = document.querySelectorAll(`[data-popup-close]`);
		buttons.forEach((element) => {
			element.addEventListener('click', (ev) => {
				ev.preventDefault();
				Popup.close();
			})
		})
	},

	initOpenButton: () => {
		const buttons = document.querySelectorAll(`[data-popup-open]`);
		buttons.forEach((element) => {
		    element.addEventListener('click', (ev) => {
				ev.preventDefault();
				const popup_name = element.getAttribute('data-popup-open');
				Popup.open(popup_name);
			})
		})
	},

	get: (popup_name) => {
		return document.querySelector(`[data-popup='${popup_name}']`);
	},

	open: (popup_name) => {
		const popup = Popup.get(popup_name);
		if(!popup){
		    return;
		}
		popup.classList.add('active');
	},
	close: () => {
		const popups = document.querySelectorAll(`[data-popup]`);
		popups.forEach((element) => {
		    element.classList.remove('active');
		    element.classList.remove('playing-video');
			const videos = element.querySelectorAll(`[data-popup-video]`);
			videos.forEach((video) => {
			    video.pause();
			})
		})
	}
}
export default Popup;
